import { useMemo } from 'react';

import { createTheme } from '@mui/material';

import { useAppInfo } from 'hooks/useAppInfo/useAppInfo';

const DEFAULT_PRIMARY = '#000000';
const DEFAULT_SECONDARY = '#000000';

const baseTheme = createTheme();

function withFallback(value: string | undefined, fallback: string): string {
  return value === undefined || value === '' ? fallback : value;
}

export function useAppTheme() {
  const { data } = useAppInfo();

  const primaryColor = withFallback(data?.primary_color, DEFAULT_PRIMARY);
  const secondaryColor = withFallback(data?.secondary_color, DEFAULT_SECONDARY);
  const bodyFontFamily = data?.body_font ? `"${data.body_font}"` : undefined;

  return useMemo(() => {
    return createTheme({
      typography: {
        fontFamily: bodyFontFamily,
      },
      palette: {
        primary: baseTheme.palette.augmentColor({
          name: 'primary',
          color: { main: primaryColor },
        }),
        secondary: baseTheme.palette.augmentColor({
          name: 'secondary',
          color: { main: secondaryColor },
        }),
      },
    });
  }, [primaryColor, secondaryColor, bodyFontFamily]);
}
